@let logoMenuOpen = store.logoMenuOpenSg();

@if (logoMenuOpen) {
  @let availableTenants = store.availableTenantsSg();
  @let expandedTenantIds = store.expandedTenantIdsSg();
  @let currentTenantId = store.currentTenantIdSg();
  @let currentZoneId = store.currentZoneIdSg();
  @let canAccessAdminPages = store.canAccessAdminPagesSg();
  @let isOnAdminPage = store.isOnAdminPageSg();
  @let canAccessGraphqlSandbox = store.canAccessGraphqlSandboxSg();
  @let isOnGraphqlSandboxPage = store.isOnGraphqlSandboxPageSg();
  @let isNotInTenant = store.isNotInTenantSg();

  <atn-ds-attached-overlay
    [origin]="originSg()"
    [offsetX]="50"
    [offsetY]="-35"
    (backdropClick)="store.toggleLogoMenuOpen()"
  >
    <div
      class="atn-navbar-logo-menu"
      [style.background-color]="store.colorSg()"
      [style.--menu-color]="store.colorSg()"
      data-test-id="logo-menu"
    >
      <div class="atn-navbar-logo-menu__tenants">
        @for (tenant of availableTenants; track tenant.id) {
          @let tenantExpanded = expandedTenantIds.has(tenant.id);

          <!-- TODO: make this its own component, ideally abstracted for apps & pages -->
          <div
            class="atn-navbar-logo-menu__tenant"
            data-test-id="tenants-list"
          >
            <div
              class="atn-navbar-logo-menu__item atn-navbar-logo-menu__item--with-icon"
              [class.atn-navbar-logo-menu__item--active]="
                tenant.id === currentTenantId && !isNotInTenant
              "
              data-test-id="tenant"
              (click)="store.toggleTenantExpanded(tenant.id)"
            >
              <span class="atn-navbar-logo-menu__item-link">
                {{ tenant.name }}
              </span>
              <i
                class="atn-navbar-logo-menu__tenant-triangle atn-icon atn-triangle-{{
                  tenantExpanded ? 'down' : 'left'
                }} atn-light"
              ></i>
            </div>

            @if (tenantExpanded) {
              <div
                class="atn-navbar-logo-menu__zones"
                data-test-id="zones-list"
              >
                @for (zone of tenant.zones; track zone.id) {
                  <a
                    class="atn-navbar-logo-menu__item"
                    [class.atn-navbar-logo-menu__item--active]="
                      zone.id === currentZoneId && !isNotInTenant
                    "
                    [routerLink]="
                      meFeature.contexts.selectors
                        .getUrlForZone({ tenant, zone })
                        .asSignal()
                    "
                    [title]="zone.name"
                    (click)="store.toggleLogoMenuOpen()"
                  >
                    {{ zone.name }}
                  </a>
                }
              </div>
            }
          </div>
        }
      </div>

      @if (canAccessAdminPages || canAccessGraphqlSandbox) {
        <atn-ds-divider />
      }
      <div class="atn-navbar-logo-menu__extras">
        @if (canAccessAdminPages) {
          <a
            class="atn-navbar-logo-menu__item"
            [class.atn-navbar-logo-menu__item--active]="isOnAdminPage"
            routerLink="/admin/tenants"
            (click)="store.toggleLogoMenuOpen()"
            data-test-id="admin-center"
          >
            Admin Center
          </a>
        }
        @if (canAccessGraphqlSandbox) {
          <a
            class="atn-navbar-logo-menu__item"
            [class.atn-navbar-logo-menu__item--active]="isOnGraphqlSandboxPage"
            routerLink="/graphql"
            (click)="store.toggleLogoMenuOpen()"
          >
            GraphQL Sandbox
          </a>
        }
      </div>
    </div>
  </atn-ds-attached-overlay>
}
